import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { toFormControl } from '@core/utils/form-utils'
import { AlbertInputnumberComponent } from '../albert-inputnumber/albert-inputnumber.component'
import { AlbertCurrencySelectComponent } from '../albert-currency-select/albert-currency-select.component'
import { AlbertInputComponent } from '../albert-input/albert-input.component'

@Component({
  selector: 'albert-limit',
  standalone: true,
  imports: [ReactiveFormsModule, AlbertInputnumberComponent, AlbertCurrencySelectComponent, AlbertInputComponent],
  templateUrl: './albert-limit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertLimitComponent {
  public readonly limitGroupName = input.required<string>()
  public readonly currencyGroupName = input.required<string>()
  public readonly limitLabel = input.required<string>()
  public readonly currencyLabel = input<string>('Currency')
  public readonly limitInputId = input.required<string>()
  public readonly currencyInputId = input.required<string>()
  public readonly disabled = input<boolean>(false)
  /** Locks only the currency select, e.g. for amounts with a fixed currency. */
  public readonly currencyDisabled = input<boolean>(false)
  public readonly required = input<boolean>(false)
  public readonly inputType = input<'number' | 'text'>('number')
  public readonly placeholder = input<string>('')
  public readonly controlName = input<string>('value')
  public readonly limitControlName = input<string>()
  public readonly currencyControlName = input<string>()
  /** `responsive` stacks limit and currency on mobile; `row` keeps them side by side on every screen size. */
  public readonly layout = input<'responsive' | 'row'>('responsive')
  /** Shows the up/down buttons of the number input. */
  public readonly showButtons = input<boolean>(false)

  public readonly actualLimitControlName = computed(() => this.limitControlName() ?? this.controlName())
  public readonly actualCurrencyControlName = computed(() => this.currencyControlName() ?? this.controlName())

  private readonly parentGroupDir = inject(FormGroupDirective)

  public readonly limitControl = computed(() => {
    const groupOrControl = this.parentGroupDir.form.get(this.limitGroupName())
    if (groupOrControl instanceof FormControl) {
      return groupOrControl
    }
    return toFormControl(groupOrControl?.get(this.actualLimitControlName()))
  })

  public readonly currencyControl = computed(() => {
    const groupOrControl = this.parentGroupDir.form.get(this.currencyGroupName())
    if (groupOrControl instanceof FormControl) {
      return groupOrControl
    }
    return toFormControl(groupOrControl?.get(this.actualCurrencyControlName()))
  })

}
